import { render, staticRenderFns } from "./LogosBlock.vue?vue&type=template&id=8afe97dc"
import script from "./LogosBlock.vue?vue&type=script&lang=ts"
export * from "./LogosBlock.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports